import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/addOns/license.addOns.grant.mutation.gql"
import type {
  LicenseAddOnGrantMutation,
  LicenseAddOnGrantMutationVariables,
} from "@/v2-backoffice-client/license/addOns/__types__/license.addOns.grant.mutation"

type Options = MutationHookOptions<
  LicenseAddOnGrantMutation,
  LicenseAddOnGrantMutationVariables
>

export function useLicenseAddOnGrantMutation(options?: Options) {
  return useMutation<
    LicenseAddOnGrantMutation,
    LicenseAddOnGrantMutationVariables
  >(mutation, options)
}
